import { SET_SEARCH_TERM, RESET_SEARCH_TERM, INIT_SEARCH_TERM } from './searchTermActionTypes';

export const setSearchTermRequest = (data) => ({
  type: SET_SEARCH_TERM,
  data
});

export const resetSearchTermRequest = () => ({
  type: RESET_SEARCH_TERM
});

export const initSearchTerm = (data) => ({
  type: INIT_SEARCH_TERM,
  data
});
